import { asyncActionMiddleware } from '@Utils/Redux/asyncAction';
import { thunk } from 'redux-thunk';
import logActionsMiddleware from './LogActionsMiddleware';

const devMiddlewares = __DEV__ ? [logActionsMiddleware] : [];

export default [
  // order important
  asyncActionMiddleware,
  thunk,
  ...devMiddlewares,
];
